import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=77d4e0e0&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d4e0e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77d4e0e0')) {
      api.createRecord('77d4e0e0', component.options)
    } else {
      api.reload('77d4e0e0', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=77d4e0e0&scoped=true&", function () {
      api.rerender('77d4e0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22jpR9RB988h9/JS/comp/Accordion.vue"
export default component.exports